import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { System } from '../models/system.model';
import { environment } from '../../environments/environment';

/**
 * 1b.1: contrato del detector de similitud. Lo usan tanto este servicio
 * como SimilarityDetectorService, que es el wrapper agnóstico que llama el
 * MasterFormComponent.
 */
export interface SimilarityMatch {
  id: string;
  name: string;
  nameSlug: string;
  client: { id: string; name: string } | null;
  distance: number;
  similarity: 'exact' | 'similar';
}

export interface CheckSimilarResponse {
  similar: SimilarityMatch[];
}

@Injectable({
  providedIn: 'root'
})
export class SystemService {

  constructor(private http: HttpClient) {}

  getAllSystems(): Observable<System[]> {
    return this.http.get<System[]>(environment.api_service_system);
  }

  getSystemById(id: string): Observable<System> {
    return this.http.get<System>(`${environment.api_service_system}/${id}`);
  }

  createSystem(system: System): Observable<System> {
    return this.http.post<System>(environment.api_service_system, system);
  }

  updateSystem(id: string, system: System): Observable<System> {
    return this.http.put<System>(`${environment.api_service_system}/${id}`, system);
  }

  deleteSystem(id: string): Observable<void> {
    return this.http.delete<void>(`${environment.api_service_system}/${id}`);
  }

  /**
   * 1b.1: invoca el endpoint de detección de similitud.
   * No tiene debounce; ése lo gestiona el componente que llama.
   */
  checkSimilar(name: string, excludeId?: string | null): Observable<CheckSimilarResponse> {
    return this.http.post<CheckSimilarResponse>(
      `${environment.api_service_system}/check-similar`,
      { name, excludeId: excludeId || null }
    );
  }
}